var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"chart3d",staticStyle:{"width":"90%","height":"90%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }